import { noop } from 'lodash';
import React from 'react';

// import default view
import { barChart as BarChartView } from './barChart.view';

/**
 * @type { function }
 * @desc A React container/smart component to render a React presentational/dumb component ( view ).
 * @param { object } Component - A React component
 * @example
 * import { BarChart } from 'modules/barChart';
 *
 * // render
 * <BarChart propName='propValue'/>
 */
export class BarChart extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			activeIndex: undefined,
		};

		// bind methods and events
		this.__bind();
	}

	// bind methods and add event listeners
	__bind() {
		this.setActiveIndex = this.setActiveIndex.bind( this );
		this.handleClickOnXAxis = this.handleClickOnXAxis.bind( this );
		this.handleHoverAction = this.handleHoverAction.bind( this );
		this.handleClickAction = this.handleClickAction.bind( this );
	}

	// Set active index to undefined
	// UNSAFE_componentWillReceiveProps() {
	// 	log.debug( 'BarChart.componentWillReceiveProps()' );

	// 	this.setState( {
	// 		activeIndex: undefined,
	// 	} );
	// }

	// Set the Active Index
	setActiveIndex( index ) {
		log.debug( 'BarChart.setActiveIndex()' );
		this.setState( {
			activeIndex: index,
		} );
	}

	// handle click on the x Axis
	handleClickOnXAxis( payload = {} ) {
		log.debug( 'BarChart.handleClickOnXAxis()', payload );

		// do something
	}

	// handle hover on the bars
	handleHoverAction( /*payload = {}, index*/ ) {
		log.debug( 'BarChart.handleHoverAction()' );

		// do something
	}

	// Handle click on Bar chart
	handleClickAction( payload = {}, index ) {
		log.debug( 'BarChart.handleClickAction()' );

		if ( payload ) {

			// set the Active index
			this.setActiveIndex( index );

			// the callback
			this.props.onClickHandler( { payload: payload, index: index } );
		}
	}

	render() {
		return (
			<BarChartView
				{ ...this.props }
				onClickOnXAxis={ this.handleClickOnXAxis }
				onHoverAction={ this.handleHoverAction }
				onClickAction={ this.handleClickAction }
				activeIndex={ this.state.activeIndex }
			/>
		);
	}
 }

// set display name
BarChart.displayName = 'BarChart';

// default props
BarChart.defaultProps = {
	barCategoryGap: 20,
	barSize: 30,
	margin: { top: 50, right: 0, left: -30, bottom: 5 },
	YaxisLine: false,
	XaxisLine: false,
	XtickLine: false,
	YtickLine: false,
	active: true,
	interval: 0,
	minTickGap: 10,
	onClickHandler: noop,
	className: '',
	data: [],
	isFetching: false,
	width: '100%'
 };

// prop types
BarChart.propTypes = {};
